export const DATETIME_FORMAT = {
    'YMDHMSS': 'YYYY-MM-DD HH:mm:ss.SSS',
    'YMDHMS': 'YYYY-MM-DD HH:mm:ss',
    'YMD': 'YYYY-MM-DD',
    'YM': 'YYYY-MM',
} as const
